import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';
import { BACKGROUND_COLOR_BLACK } from '~/src/features/movix-new/constants';

export const VideoServicesWrapper = styled.div`
    position: relative;
    width: 100%;
    margin-top: -2px;
    background-color: ${BACKGROUND_COLOR_BLACK};

    @media (min-width: 1024px) {
        position: absolute;
        top: -10px;
        height: 530px;
    }

    @media (min-width: 1366px) {
        height: 610px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        height: auto;
    }
`;

export const Container = styled.div`
    display: block;
    color: ${COLORS.TextWhite};
    z-index: 1;
    max-width: 1356px;
    width: 100%;
    margin: 86px auto 0 auto;

    @media (max-width: ${breakPoints.desktop}) {
        max-width: 1226px;
        margin-top: 98px;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        max-width: 929px;
        margin-top: 71px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        margin: 5px auto 0 auto;
        text-align: center;
    }

    @media (max-width: ${breakPoints.mobile}) {
        padding: 0 24px;
        width: 100%;
        margin-left: auto;
    }
`;

export const Title = styled.div`
    width: 450px;
    height: fit-content;
    ${FONTS.H2};

    @media (max-width: ${breakPoints.sDesktop}) {
        width: 430px;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        width: 430px;
        ${FONTS.H3};
    }

    @media (max-width: ${breakPoints.tablet}) {
        width: 100%;
        justify-content: center;
    }

    @media (max-width: ${breakPoints.mobile}) {
        justify-content: center;
        text-align: center;
        ${FONTS.H4};
    }
`;

export const SubText = styled.div`
    width: 450px;
    height: fit-content;
    ${FONTS.M};
    margin-top: 10px;

    @media (max-width: ${breakPoints.sDesktop}) {
        ${FONTS.XS};
    }

    @media (max-width: ${breakPoints.tablet}) {
        width: 100%;
        margin-top: 12px;
        justify-content: center;
    }

    @media (max-width: ${breakPoints.mobile}) {
        line-height: 1.71;
        text-align: center;
        justify-content: center;
    }
`;

export const ImgServices = styled(LazyLoadImage)`
    max-width: 400px;
    height: auto;
    margin-top: 23px;
    image-rendering: -moz-crisp-edges;
    image-rendering: -o-crisp-edges;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;

    @media (max-width: ${breakPoints.tablet}) {
        margin-top: 16px;
        justify-content: center;
    }

    @media (max-width: ${breakPoints.mobile}) {
        max-width: 250px;
        margin-top: 27px;
    }
`;

export const Img = styled.img`
    object-fit: content;
`;

export const ImgYouTube = styled(LazyLoadImage)`
    margin: 0 10px 3px 10px;

    @media (max-width: ${breakPoints.mobile}) {
        margin-bottom: 5px;
    }
`;
